/* Recommended for you -- a small row of add-ons inside the cart drawer.

   One product is drawn from each collection the section lists, and the draw is
   made again every time the drawer is opened. Rather than shipping the whole
   catalogue into every page, each pick is one request for one product: the
   collection's size comes from Liquid, a page number is rolled against it, and
   the storefront returns that single product. Nothing is fetched until someone
   actually opens their bag. */
(function(){
"use strict";

var TAG = document.currentScript || document.querySelector("script[data-cart-upsell]");
if (!TAG) return;

var HEADING = TAG.getAttribute("data-heading") || "Recommended for you";
var CURRENCY = TAG.getAttribute("data-currency") || "USD";
var ADD = TAG.getAttribute("data-add") || "Add";
var GROUPS = [];
try { GROUPS = JSON.parse(TAG.getAttribute("data-groups") || "[]"); } catch(e){ GROUPS = []; }
if (!GROUPS.length) return;

var picks = null;      /* what is on screen now, so a cart edit does not reshuffle it */
var loading = false;

function drawer(){ return document.getElementById("CartDrawer"); }
function host(){ return document.querySelector("cart-drawer"); }
function keyOf(list){ return (list || []).map(function(p){ return p.handle; }).join("|"); }

function money(value){
  var n = parseFloat(value);
  if (isNaN(n)) return "";
  try { return new Intl.NumberFormat(undefined, { style:"currency", currency:CURRENCY }).format(n); }
  catch(e){ return n.toFixed(2); }
}

function thumb(src){
  if (!src) return "";
  return src + (src.indexOf("?") > -1 ? "&" : "?") + "width=240";
}

/* ---------- fitting the photo to its tile ----------
   The photos are exported onto one fixed canvas whatever the product is, so a
   laptop sleeve sits as a thin band with a lot of white above and below it
   while a phone case nearly fills the frame. Dropped into the same tile, the
   sleeve comes out a quarter of the size of everything else.

   So: find where the product actually is in the photo, and zoom until it fills
   its tile. The measuring is done on a second, off-screen copy of the image --
   if the CDN ever refuses a cross-origin read, the measurement is abandoned
   and the visible photo is left exactly as it was. */
var FILL = 0.92;       /* leave a little air rather than touching the edges */
var MAX_ZOOM = 2.6;    /* past this we would be enlarging a thumbnail */

function fitToTile(img, tile){
  var probe = new Image();
  probe.crossOrigin = "anonymous";
  probe.onload = function(){
    var nw = probe.naturalWidth, nh = probe.naturalHeight;
    var W = tile.clientWidth, H = tile.clientHeight;
    if (!nw || !nh || !W || !H) return;

    /* A small copy is plenty to find the edges of the product. */
    var c = document.createElement("canvas");
    var s = Math.min(1, 160 / Math.max(nw, nh));
    c.width = Math.max(1, Math.round(nw * s));
    c.height = Math.max(1, Math.round(nh * s));

    var data;
    try {
      var x = c.getContext("2d");
      x.drawImage(probe, 0, 0, c.width, c.height);
      data = x.getImageData(0, 0, c.width, c.height).data;
    } catch(e){ return; }          /* tainted canvas: leave the photo alone */

    var minX = c.width, minY = c.height, maxX = -1, maxY = -1;
    for (var y = 0; y < c.height; y++){
      for (var px = 0; px < c.width; px++){
        var i = (y * c.width + px) * 4;
        if (data[i+3] < 16) continue;                                    /* transparent */
        if (data[i] > 246 && data[i+1] > 246 && data[i+2] > 246) continue; /* white */
        if (px < minX) minX = px;
        if (px > maxX) maxX = px;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }
    if (maxX < 0) return;          /* nothing but background: nothing to do */

    var fw = (maxX - minX + 1) / c.width;
    var fh = (maxY - minY + 1) / c.height;
    /* How far the product's middle sits from the middle of the photo. */
    var offX = ((minX + maxX) / 2) / c.width  - 0.5;
    var offY = ((minY + maxY) / 2) / c.height - 0.5;

    /* The size object-fit:contain is already drawing it at. */
    var fit = Math.min(W / nw, H / nh);
    var dw = nw * fit, dh = nh * fit;

    var k = Math.min(W * FILL / (fw * dw), H * FILL / (fh * dh));
    k = Math.max(1, Math.min(k, MAX_ZOOM));
    if (k <= 1.02) return;         /* already filling its tile */

    img.style.transform =
      "translate(" + (-offX * dw * k).toFixed(1) + "px," +
                     (-offY * dh * k).toFixed(1) + "px) scale(" + k.toFixed(3) + ")";
  };
  probe.src = img.currentSrc || img.src;
}

function fitAll(wrap){
  var tiles = wrap.querySelectorAll(".cart-upsell__media");
  for (var i = 0; i < tiles.length; i++){
    (function(tile){
      var im = tile.querySelector("img");
      if (!im) return;
      if (im.complete && im.naturalWidth) fitToTile(im, tile);
      else im.addEventListener("load", function(){ fitToTile(im, tile); }, { once:true });
    })(tiles[i]);
  }
}

/* One product, chosen by rolling a page number against the collection's size. */
function pick(group, skip){
  var total = Math.max(1, group.count || 1);
  var page = 1 + Math.floor(Math.random() * Math.min(total, 250));
  var url = "/collections/" + encodeURIComponent(group.handle) + "/products.json?limit=1&page=" + page;
  return fetch(url, { headers:{ "Accept":"application/json" } })
    .then(function(r){ return r.json(); })
    .then(function(j){
      var p = j && j.products && j.products[0];
      if (!p) return null;
      if (skip.indexOf(p.handle) > -1) return null;
      var vs = (p.variants || []).filter(function(v){ return v.available; });
      if (!vs.length) return null;
      return {
        title: p.title,
        handle: p.handle,
        image: thumb(p.images && p.images[0] && p.images[0].src),
        variants: vs.map(function(v){ return { id:v.id, title:v.title, price:v.price }; })
      };
    })
    .catch(function(){ return null; });
}

function draw(){
  if (loading) return Promise.resolve(picks);
  loading = true;
  return fetch("/cart.js", { headers:{ "Accept":"application/json" }, credentials:"same-origin" })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      var skip = (cart.items || []).map(function(i){ return i.handle; });
      /* Two rolls per collection: the first may land on something already in
         the bag, or on a sold-out product. */
      return Promise.all(GROUPS.map(function(g){
        return pick(g, skip).then(function(p){ return p || pick(g, skip); });
      }));
    })
    .then(function(list){
      picks = list.filter(Boolean);
      return picks;
    })
    .catch(function(){ return picks; })
    .then(function(p){ loading = false; return p; });
}

function card(p){
  var el = document.createElement("div");
  el.className = "cart-upsell__card";

  var a = document.createElement("a");
  a.className = "cart-upsell__media";
  a.href = "/products/" + p.handle;
  if (p.image){
    var im = document.createElement("img");
    im.src = p.image; im.alt = p.title; im.loading = "lazy";
    a.appendChild(im);
  }
  el.appendChild(a);

  var name = document.createElement("a");
  name.className = "cart-upsell__name";
  name.href = "/products/" + p.handle;
  name.textContent = p.title;
  el.appendChild(name);

  var price = document.createElement("p");
  price.className = "cart-upsell__price";
  price.textContent = money(p.variants[0].price);

  var sel = null;
  if (p.variants.length > 1){
    sel = document.createElement("select");
    sel.className = "cart-upsell__pick";
    sel.setAttribute("aria-label", p.title + " option");
    p.variants.forEach(function(v){
      var o = document.createElement("option");
      o.value = v.id; o.textContent = v.title;
      sel.appendChild(o);
    });
    sel.onchange = function(){
      var v = p.variants.filter(function(x){ return String(x.id) === sel.value; })[0];
      if (v) price.textContent = money(v.price);
    };
    el.appendChild(sel);
  }

  var btn = document.createElement("button");
  btn.type = "button";
  btn.className = "cart-upsell__add";
  btn.textContent = ADD;
  btn.onclick = function(){
    btn.disabled = true;
    add(sel ? sel.value : p.variants[0].id).catch(function(){ btn.disabled = false; });
  };

  /* Price and button share the bottom line -- two stacked full-width controls
     is what made the strip tall. */
  var foot = document.createElement("div");
  foot.className = "cart-upsell__foot";
  foot.appendChild(price);
  foot.appendChild(btn);
  el.appendChild(foot);

  return el;
}

/* Adding through the theme's own section rendering keeps the drawer open and
   lets it redraw its items, totals and bubble the way it normally would. */
function add(id){
  var body = new FormData();
  body.append("id", String(id));
  body.append("quantity", "1");
  body.append("sections", "cart-drawer,cart-icon-bubble");
  body.append("sections_url", window.location.pathname);
  return fetch("/cart/add.js", {
    method:"POST", body:body, credentials:"same-origin",
    headers:{ "Accept":"application/javascript" }
  })
    .then(function(r){ return r.json(); })
    .then(function(res){
      var h = host();
      if (h && typeof h.renderContents === "function") h.renderContents(res);
      else window.location.reload();
    });
}

function render(){
  var d = drawer();
  if (!d || !picks || !picks.length) return;
  var footer = d.querySelector(".drawer__footer");
  var items = d.querySelector("cart-drawer-items");
  if (!footer || !items || items.classList.contains("is-empty")) return;

  var key = keyOf(picks);
  var old = d.querySelector(".cart-upsell");
  /* Already showing these exact picks -- leave the row alone so an open
     dropdown or a half-made choice is not thrown away. */
  if (old && old.getAttribute("data-keys") === key) return;
  if (old && old.parentNode) old.parentNode.removeChild(old);

  var wrap = document.createElement("div");
  wrap.className = "cart-upsell";
  wrap.setAttribute("data-keys", key);
  var h = document.createElement("p");
  h.className = "cart-upsell__title";
  h.textContent = HEADING;
  var row = document.createElement("div");
  row.className = "cart-upsell__row";
  picks.forEach(function(p){ row.appendChild(card(p)); });
  wrap.appendChild(h);
  wrap.appendChild(row);
  footer.parentNode.insertBefore(wrap, footer);
  /* Tiles have a size now that they are on the page, so the photos can be
     measured against them. */
  fitAll(wrap);
}

function reshuffle(){ draw().then(render); }

function start(){
  /* Nothing is fetched on a page view -- only when the bag is opened. */
  document.addEventListener("click", function(ev){
    var t = ev.target.closest && ev.target.closest("#cart-icon-bubble, [aria-controls='CartDrawer']");
    if (t) setTimeout(reshuffle, 140);
  }, true);

  var h = host();
  if (!h) return;

  /* The drawer also opens on its own after an add from a product page. */
  new MutationObserver(function(){
    if (h.classList.contains("active") && !document.querySelector(".cart-upsell")) reshuffle();
  }).observe(h, { attributes:true, attributeFilter:["class"] });

  /* A cart edit redraws the drawer and wipes the row -- put the same picks
     back rather than rolling new ones mid-edit. */
  var d = drawer();
  if (!d) return;
  var pending = null;
  new MutationObserver(function(muts){
    for (var i=0;i<muts.length;i++){
      var t = muts[i].target;
      var node = t && t.nodeType === 1 ? t : (t && t.parentElement);
      if (node && node.closest && node.closest(".cart-upsell, .cart-skin__ship, .cart-skin__sub")) continue;
      clearTimeout(pending);
      pending = setTimeout(render, 90);
      return;
    }
  }).observe(d, { childList:true, subtree:true });
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
else start();

})();
